import { Burger, Button, type ComboboxItem } from '@mantine/core';
import { useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { SidebarButton } from '@/components/SidebarButton';
import { IssueReportComponent } from '@/components/IssueReport/IssueReportComponent';
import { useAuth } from '@/AuthProvider';
import { subPath } from '@/subpath.config';
import { Image } from '@mantine/core';

export const navOptions: ComboboxItem[] = [
  {
    label: 'Klienti',
    value: 'clients',
  },
  {
    label: 'Zájemci',
    value: 'applicants',
  },
  {
    label: 'Zaměstnanci',
    value: 'employees',
  },
  {
    label: 'Uživatelé',
    value: 'users',
  },
  {
    label: 'Plánování',
    value: 'planning/overview',
  },
  {
    label: 'Statistika',
    value: 'statistics',
  },
];

export const SidebarLayout = (): JSX.Element => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  const location = useLocation();
  const navigate = useNavigate();
  const { setToken } = useAuth();

  const [selectedSection, setSelectedSection] = useState<string>(
    // Get the first word from the path, for example /employees/13/details => employees
    location.pathname.split('/')[1]
  );

  const handleClick = (): void => {
    setMenuOpen(!menuOpen);
  };

  const handleLogout = (): void => {
    setToken(null);
    navigate('/login');
  };

  const handleLogoClick = (): void => {
    setSelectedSection('my-account');
    navigate('/my-account');
  };

  const proszLogoSvgPath = `${subPath}/prosazLogo.svg`;
  return (
    <div className="flex flex-col sm:flex-row">
      <div className="sm:w-56 flex flex-col bg-polar-lights p-2.5">
        <div className="flex justify-between items-center">
          <Burger
            color="white"
            className="sm:hidden pl-4"
            onClick={handleClick}
            opened={menuOpen}
          />
          <Image
            className="w-14 h-14 sm:w-24 sm:h-24 hover:cursor-pointer"
            src={proszLogoSvgPath}
            alt="Logo"
            onClick={handleLogoClick}
          />
        </div>
        <div
          className={`${menuOpen ? 'flex' : 'hidden'} sm:flex grow flex-col justify-between`}
        >
          <div className="flex flex-col gap-2.5 mb-2.5">
            {navOptions.map(option => (
              <SidebarButton
                key={option.value}
                to={option.value}
                label={option.label}
                selected={option.value.includes(selectedSection)}
                onSelect={() => {
                  setSelectedSection(option.value);
                }}
              />
            ))}
          </div>
          <div className="flex flex-col gap-2.5">
            <SidebarButton
              key={'tags'}
              to="tags"
              selected={selectedSection === 'tags'}
              label="Tagy"
              onSelect={() => {
                setSelectedSection('tags');
              }}
            />
            <SidebarButton
              key={'locations'}
              to="locations"
              selected={selectedSection === 'locations'}
              label="Lokace"
              onSelect={() => {
                setSelectedSection('locations');
              }}
            />
            <SidebarButton
              key={'services'}
              to="services"
              selected={selectedSection === 'services'}
              label="Služby"
              onSelect={() => {
                setSelectedSection('services');
              }}
            />
            <SidebarButton
              key={'my-account'}
              to="my-account"
              selected={selectedSection === 'my-account'}
              label="Můj účet"
              onSelect={() => {
                setSelectedSection('my-account');
              }}
            />
            <IssueReportComponent />

            <Link key="/logout" to="/login">
              <Button
                variant="outline"
                fullWidth
                className="flex justify-start border-white text-heading2 text-slate-50 hover:text-black rounded-lg bg-transparent hover:bg-white"
                onClick={handleLogout}
              >
                Odhlásit se
              </Button>
            </Link>
          </div>
        </div>
      </div>
      <div className="flex-1 sm:h-screen overflow-auto">
        <Outlet />
      </div>
    </div>
  );
};
